var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcAddyoutube = function SvgIcAddyoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ic_addyoutube_svg__st0",
    d: "M12.7 16.1c0-3.5 3-6.4 6.5-6.4.4 0 .8-.4.8-.8V7.5c0-2-1.5-3.6-3.8-4-4.1-.7-8.3-.7-12.4 0-2.3.5-3.8 2-3.8 4v7c0 2 1.5 3.5 3.8 4 2 .3 4.1.5 6.2.5.9 0 1.7 0 2.5-.1.4 0 .7-.4.5-.8-.1-.6-.3-1.3-.3-2zm-4.4-1.6c-.1 0-.2.1-.3.1-.1 0-.2 0-.2-.1-.2-.1-.3-.3-.2-.5V8c0-.2.1-.3.2-.4.2-.1.4-.1.5 0l5 3c.2.2.3.5.2.7 0 .1-.1.1-.2.2l-5 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ic_addyoutube_svg__st0",
    d: "M19.1 11.1c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9S24 18.7 24 16s-2.2-4.9-4.9-4.9zm1.8 5.8h-1v1c0 .4-.4.8-.8.8s-.8-.4-.8-.8v-1h-1c-.4 0-.8-.4-.8-.8s.4-.8.8-.8h1v-1c0-.4.4-.8.8-.8s.8.4.8.8v1h1c.4 0 .8.4.8.8s-.3.8-.8.8z"
  })));
};
export default SvgIcAddyoutube;